import { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getModuleByIdStart } from '../../../Store/Slices/formSlice';
import { conditions, moduleForm } from "../../../Constant/moduleForm";

const TerritoryRuleBuilder = ({ isOpen, onClose, handleRule, isCreateRule, territoryData }) => {
  console.log('tr data--->', territoryData)
  const [showModal, setShowModal] = useState(isOpen);
  const [criteria, setCriteria] = useState([
    { id: 1, field: 'None', operator: 'None', value: '', logic: 'AND' },
    { id: 2, field: 'None', operator: 'None', value: '', logic: 'OR' },
    { id: 3, field: 'None', operator: 'None', value: '', logic: 'OR' },
    { id: 4, field: 'None', operator: 'None', value: '' }
  ]);

  // dp changes::start

  const dispatch = useDispatch();
  let subformList = useSelector((state) => state?.forms)
  let formList = subformList?.modules;

  let [fieldList, setFieldList] = useState([])
  let [sectionsData, setSectionsData] = useState([]);
  let [ruleData, setRuleData] = useState({
    conditions: [{
      id: '',
      field: '',
      type: '',
      condition: '',
      value: ''
    }]
  })

  const formConditionHandler = (e, index) => {
    try {
      const { name, value } = e?.target;
      if (name !== 'field') {
        setRuleData((prevUser) => ({
          ...prevUser,
          conditions: prevUser.conditions.map((condition, i) =>
            i === index ? {
              ...condition,
              [name]: value
            } : condition
          )
        }));
      } else {
        let id = value.split('#')[0];
        let type = value.split('#')[2];
        setRuleData((prevUser) => ({
          ...prevUser,
          conditions: prevUser.conditions.map((condition, i) =>
            i === index ? {
              ...condition,
              [name]: value,
              'type': type,
              'id': id
            } : condition
          )
        }));
      }
    } catch (err) {
      throw err;
    }
  }

  const handleAddField = () => {
    const newItem = {
      field: '',
      condition: '',
      value: ''
    }
    setRuleData((prevUser) => ({
      ...prevUser,
      conditions: [...prevUser.conditions, newItem]
    }));
  }

  const handleRemoveField = (index) => {
    if (ruleData.conditions.length > 1)
      setRuleData((prev) => ({
        ...prev,
        conditions: prev.conditions.filter((_, i) => i !== index)
      }));
  }

  useEffect(() => {
    if (subformList?.navbarList?.length && !formList) {
      const selectedModule = subformList?.navbarList.find(obj => obj.name === "Accounts");
      dispatch(getModuleByIdStart(selectedModule?._id))
    }
  }, [subformList])

  useEffect(() => {
    if (formList?.length > 0) {
      setFieldList([]);
      let sections = formList?.[0]?.fields?.sections;
      setSectionsData(sections.map(option => option.section_name && {
        label: option.section_name,
        value: option.section_name
      }));
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].dropped_list) {
          let list = sections[i].dropped_list
          let o_val = Object.values(list)
          for (var j = 0; j < o_val.length; j++) {
            for (var k = 0; k < o_val[j].length; k++) {
              let _value = o_val[j][k];
              setFieldList(list => [...list, _value])
            }
          }
        }
      }
    }
  }, [formList])

  useEffect(() => {
    if (!isCreateRule) {
      setRuleData((prev) => ({
        ...prev,
        conditions: territoryData?.account_rule
      }));
    }
  }, [isCreateRule])

  // dp changes::end

  useEffect(() => {
    setShowModal(isOpen);
  }, [isOpen]);

  const addCriterion = () => {
    const newId = criteria.length > 0 ? Math.max(...criteria.map(c => c.id)) + 1 : 1;
    setCriteria([...criteria, { id: newId, field: 'None', operator: 'None', value: '', logic: 'OR' }]);
  };

  const removeCriterion = (id) => {
    if (criteria.length > 1) {
      setCriteria(criteria.filter(c => c.id !== id));
    }
  };

  // const getPattern = () => {
  //   if (ruleData?.conditions.length === 0) return '';

  //   let pattern = '( ( (';
  //   ruleData?.conditions.forEach((criterion, index) => {
  //     if (index > 0) {
  //       pattern += ` ${ruleData?.conditions[index - 1].logic} `;
  //     }
  //     pattern += criterion.id;
  //   });
  //   pattern += ' ) ) )';

  //   return pattern;
  // };

  const getCriteria = (length) => {
    if (length === 0) return '';
    if (length === 1) return '1';
    if (length === 2) return '(1 and 2)';

    const previous = getCriteria(length - 1);
    return `(${previous} and ${length})`;
  };

  const handleDone = () => {
    handleRule(ruleData, territoryData)
    onClose();
  };

  return (
    <div
      className={`modal fade ${showModal ? 'show d-block' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body p-4">
            <h2 className="fs-4 fw-normal mb-1">Add Account Rule</h2>
            <p className="text-muted mb-4">To automatically assign territories to records, please fill out the rule criteria</p>

            {/* conditions::start */}
            {ruleData?.conditions?.map((dta, index) => (
              <Row className="mt-3 m-0">
                <div className="col-3">
                  <select
                    className="form-select"
                    id="sub-select"
                    name="field"
                    value={dta?.field}
                    onChange={(e) => formConditionHandler(e, index)}
                  >
                    <option value="" disabled selected>Select</option>
                    {fieldList.map((data) => (
                      <option value={data?.id + '#' + data?.extra_fields?.field_label + '#' + data?.input_type}>
                        {data?.extra_fields?.field_label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-3">
                  <select
                    className="form-select"
                    id="sub-select"
                    name="condition"
                    value={dta.condition}
                    onChange={(e) => formConditionHandler(e, index)}
                  >
                    <option value="" disabled selected>Select</option>
                    {conditions.map((condition) => (
                      <option value={condition.name + '#' + condition.value}>
                        {condition.value}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-3">
                  {dta?.condition !== 'is_empty' && dta?.condition !== 'isnt_empty' && <>
                    {dta?.type == 'select' || dta?.type == 'multi-select' ?
                      <select
                        className="form-select"
                        id="sub-select"
                        name="value"
                        value={dta.value}
                        onChange={(e) => formConditionHandler(e, index)}
                      >
                        <option value="" disabled selected>Select</option>
                        {dta?.type == 'select' && fieldList.map((field) =>
                          field.id == dta.id && (
                            <>
                              {field?.extra_fields?.options.map((item) => (
                                <option key={item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </>
                          ))
                        }
                        {dta?.type == 'multi-select' && fieldList.map((field) =>
                          field.id == dta.id && (
                            <>
                              {field?.extra_fields?.options.map((item) => (
                                <option key={item.name} value={item.name}>
                                  {item.name}
                                </option>
                              ))}
                            </>
                          ))
                        }
                      </select>
                      :
                      <input
                        type="text"
                        name="value"
                        className="form-control"
                        value={dta.value}
                        onChange={(e) => formConditionHandler(e, index)}
                      />
                    }
                  </>
                  }
                </div>
                <div class="col-2 d-flex">
                  <button type="button" class="btn btn-light rounded-circle p-0 me-2" title="New Product" style={{ border: '3px solid rgb(240, 234, 234)', height: '30px', width: '30px' }}
                    onClick={handleAddField}>+</button>
                  <button type="button" class="btn btn-light rounded-circle p-0" title="Remove Product" style={{ border: '3px solid rgb(240, 234, 234)', height: '30px', width: '30px' }}
                    onClick={() => handleRemoveField(index)}>-</button>
                </div>
              </Row>
            ))}
            {/* conditions end */}

            {/* {criteria.map((criterion, index) => (
              <div key={criterion.id} className="row mb-3 align-items-center">
                <div className="col-auto">
                  <div
                    className="rounded-circle bg-white border d-flex align-items-center justify-content-center"
                    style={{ width: '32px', height: '32px' }}
                  >
                    {criterion.id}
                  </div>
                </div>

                <div className="col-3">
                  <div className="dropdown">
                    <button className="btn btn-outline-secondary dropdown-toggle w-100 text-start" type="button">
                      {criterion.field}
                    </button>
                    <ul className="dropdown-menu w-100">
                      {['None', 'Account Name', 'Country', 'State/Province'].map((option) => (
                        <li key={option}>
                          <a className="dropdown-item" href="#">{option}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-3">
                  <div className="dropdown">
                    <button className="btn btn-outline-secondary dropdown-toggle w-100 text-start" type="button">
                      {criterion.operator}
                    </button>
                    <ul className="dropdown-menu w-100">
                      {['None', 'Equals', 'Contains', 'Starts with'].map((op) => (
                        <li key={op}>
                          <a className="dropdown-item" href="#">{op}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    value={criterion.value}
                    onChange={() => { }}
                    placeholder=""
                  />
                </div>

                <div className="col-auto">
                  <button className="btn btn-link text-danger p-0" onClick={() => removeCriterion(criterion.id)}>
                    <i className="bi bi-x-circle" style={{ fontSize: '20px' }}></i>
                  </button>
                </div>

                {index < criteria.length - 1 && (
                  <div className="col-12 offset-2 mt-2 mb-2">
                    <div className="text-primary fw-bold">{criterion.logic}</div>
                  </div>
                )}
              </div>
            ))} */}

            {/* <div className="mt-2 mb-4">
              <button className="btn btn-link text-success p-0" onClick={addCriterion}>
                <i className="bi bi-plus-circle" style={{ fontSize: '20px' }}></i>
                Add Condition
              </button>
            </div> */}

            {ruleData?.conditions?.length > 1 &&
              <div className="row mt-3 mb-5">
                <div className="col-auto d-flex align-items-center">
                  <span className="fw-medium">Criteria Pattern</span>
                  <i className="bi bi-question-circle text-primary ms-2" style={{ fontSize: '16px' }}></i>
                </div>
                <div className="col">
                  <span className="text-muted">{getCriteria(ruleData?.conditions?.length)}</span>
                  {/* <button className="btn btn-link ms-2 text-primary p-0">Edit Pattern</button> */}
                </div>
              </div>
            }

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-light" onClick={onClose}>Cancel</button>
              <button className="btn btn-primary" onClick={handleDone}>Done</button>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default TerritoryRuleBuilder